import { useMemo, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE || '';

function GenerateForm({ compact = false }) {
  const [city, setCity] = useState('Sacramento, CA');
  const [minReviews, setMinReviews] = useState('5');

  const downloadUrl = useMemo(() => {
    const params = new URLSearchParams();
    if (city.trim()) params.append('city', city.trim());
    if (minReviews.trim()) params.append('min_reviews', minReviews.trim());
    return `${API_BASE}/backend/leads.php?${params.toString()}`;
  }, [city, minReviews]);

  return (
    <div className={compact ? 'panel compact' : 'panel'}>
      <h2>Generate CSV</h2>
      <div className="row">
        <label>
          City
          <input value={city} onChange={(e) => setCity(e.target.value)} placeholder="Sacramento, CA" />
        </label>
        <label>
          Min Reviews
          <input value={minReviews} onChange={(e) => setMinReviews(e.target.value)} placeholder="5" />
        </label>
      </div>
      <div className="row">
        <a className="primary" href={downloadUrl}>Generate CSV</a>
        <span className="hint">Opens a download using the current filters.</span>
      </div>
    </div>
  );
}

export default GenerateForm;
